import type {
  QueryVars,
  Filters as FilterQueryVars,
} from '@/lib/apollo/query/get-fraud-subjects'

import type { FilterT } from './Filter'
import type { SearchValues } from './FilterPanel'

interface ToQueryVarsArgs {
  customerId: string
  limit: number
  offset: number
  searchValues: SearchValues
}

const toFilterQueryVars = (filter: FilterT): FilterQueryVars => ({
  fraudSettings: filter.fraudSettings,
  sla: filter.sla,
  ageOfReference: filter.ageOfReference,
  cifas: filter.cifas,
  tenancyStartDate: filter.tenancyStartDate,
})

export const toQueryVars = ({
  customerId,
  limit,
  offset,
  searchValues,
}: ToQueryVarsArgs): QueryVars => ({
  customerId,
  filter: toFilterQueryVars(searchValues.filter),
  limit,
  offset,
})
